<template>
  <!-- 外层只负责把高度撑出来，避免页面抖动 -->
  <div ref="wrap" class="scale-wrap">
    <!-- 真正渲染区域：以 750 宽为基准，整体 transform:scale -->
    <div
      ref="inner"
      class="scale-inner"
      :style="scaleStyle"
    >
      <slot />          <!-- 这里放你原来的“未适配 H5”的桌面组件 -->
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue'

const wrap = ref()
const inner = ref()
const scaleStyle = reactive({
  transform: 'scale(1)',
  transformOrigin: 'left top',
  width: '1200px'          // 设计稿基准
})

const updateScale = () => {
  if (!wrap.value || !inner.value) return
  const cw = wrap.value.clientWidth          // 实际视口宽度
  const base = 1200                           // 设计稿宽度
  const ratio = cw / base
  scaleStyle.transform = `scale(${ratio})`
  // 把高度同步回去，避免下方 DOM 塌陷
  wrap.value.style.height = inner.value.offsetHeight * ratio + 'px'
}

/* 监听函数集合，方便销毁 */
let mo, ro

onMounted(() => {
  /* 1. 子树变化（节点增减、文本变化） */
  mo = new MutationObserver(() => updateScale())
  mo.observe(inner.value, {
    childList: true,
    subtree: true,
    characterData: true
  })

  /* 2. 子元素尺寸变化（图片加载、表格展开等） */
  ro = new ResizeObserver(() => updateScale())
  ro.observe(inner.value)
  updateScale()
  window.addEventListener('resize', updateScale)
})
onBeforeUnmount(() => {
  mo?.disconnect()
  ro?.disconnect()
  window.removeEventListener('resize', updateScale) 
}) 
</script>

<style scoped>
.scale-wrap {
  width: 100%;
  overflow: hidden;   /* 把可能出现的横向滚动条藏掉 */
}
.scale-inner {
  width: 750px;
}
</style>